// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import TextField from '@mui/material/TextField'
import React from 'react'
import { i18n } from '../../index'
import css from './Users.css'
import type { User } from './userTypes'

const UserFormFields = ({ data }: { data: User }) => (
  <div className={css.formFields}>
    <div className={css.formRow}>
      <TextField
        data-testid='user-givenname'
        label={i18n.t('admin.user.givenName')}
        value={data.givenName || ' '}
        disabled
        fullWidth
      />
      <TextField
        data-testid='user-surname'
        label={i18n.t('admin.user.surname')}
        value={data.surname || ' '}
        disabled
        fullWidth
      />
    </div>
    <div className={css.formRow}>
      <TextField
        data-testid='user-principalname'
        label={i18n.t('admin.user.principalName')}
        value={data.principalName || ' '}
        disabled
        fullWidth
      />
      <TextField
        data-testid='user-samaccountname'
        label={i18n.t('admin.user.samAccountName')}
        value={data.samAccountName || ' '}
        disabled
        fullWidth
      />
    </div>
    <div className={css.formRow}>
      <TextField
        data-testid='user-usertype'
        label={i18n.t('admin.user.userType')}
        value={i18n.t(`admin.user.${data.userType}`) || ' '}
        disabled
        fullWidth
      />
      <TextField
        data-testid='user-company'
        label={i18n.t('admin.user.company')}
        value={data.company ? data.company.name : ' '}
        disabled
        fullWidth
      />
    </div>
    <div className={css.formRow}>
      <TextField
        data-testid='user-employeeid'
        label={i18n.t('admin.user.employeeId')}
        value={data.employeeId || ' '}
        disabled
        fullWidth
      />
    </div>
  </div>
)

export default UserFormFields
